import React from "react";
import { MailOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Button, Tag } from "antd";
import styles from "@buddieshr/styles/components/nonprofit.module.scss";

const NonProfit = ({ app }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.NonProfit_wrapper}>
      <div className={styles.NonProfit_inner}>
        <Tag
          color="blue"
          size="large"
          className={styles.bold}
          style={{
            padding: "3px 14px",
            borderRadius: "4px",
            fontSize: "14px",
            marginBottom: "8px",
          }}
        >
          {t("freeForeverUppercase")}
        </Tag>
        <div className={styles.NonProfit_title}>{t("nonProfitTitle")}</div>
        <div className={styles.NonProfit_content}>
          {t("nonProfitDesc", { appName: app.name })}
        </div>
        <div>
          <a
            href="mailto:contact@buddieshr.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button
              icon={<MailOutlined />}
              size="large"
              type="primary"
              style={{ margin: "inherit" }}
            >
              {t("contactUs")}
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default NonProfit;
